import React from "react";
import { useNavigate } from "react-router-dom";
import { BottomNavigation } from "./header";
import { CourseTable } from "./course";
import {Avatar} from 'primereact/avatar';
import Logo from "../../../assets/logo.png";
import { useAuthChauffeur } from "./auth";

export const EspaceChauffeur = () => {
  const { logout } = useAuthChauffeur();
  const navigate = useNavigate();

  const handleLogout = () => {
        logout(); 
        navigate("/chauffeur/login");
    };

  return (
    <div>
      <main
        style={{
          margin: "0 auto",
      }}
      >
        <CourseTable />
      </main>

      <BottomNavigation />
    </div>
  );
};